import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
const FileUpload = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [statusCC, setStatusCC] = useState(null);
  const [statusTF, setStatusTF] = useState(null);
  const [errorCodeCC, setErrorCodeCC] = useState(null);
  const [riverchainID, setRiverchainID] = useState(null);
  const [borrowerNameEng, setBorroerNameEng] = useState(null);
  const [finalUpload, setFinalUpload] = useState(false);
  const [registeredAddress, setRegisteredAddress] = useState(null);
  const [placeofincorporation, setPlaceofincorporation] = useState(null);
  const [contactname, setContactname] = useState(null);
  const [contactemailaddress, setContactemailaddress] = useState(null);
  const [contactphonenumber, setContactphonenumber] = useState(null);
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);
  const [bankName, setBankName] = useState(null);
  const [bankAccNo, setBankAccNo] = useState(null);
  const [benifiserName, setBenifiserName] = useState(null);
  const [bankCode, setBankCode] = useState(null);
  const [swift, setSwift] = useState(null);

  const [statusRes, setStatusRes] = useState(null);

  //   TF
  const [errorCodeTF, SetErrorCodeTF] = useState(null);
  const [lenderNo, setLenderNo] = useState(null);
  const [productNo, setProductNo] = useState(null);
  const [facilityLimit, setFacilityLimit] = useState(null);
  const [drawDownAvailability, SetDrawDownAvailability] = useState(null);
  const [interestRate, setInterestRate] = useState(null);
  const [maxTerm, setMaxTerm] = useState(null);
  const [repaymentOne, setRepaymentOne] = useState(null);
  const [invoiceAmount, setInvoiceAmount] = useState(null);
  const [invoiceFinancing, setInvoiceFinancing] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);
  const [contractStartDate, setContractStartDate] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [borrowerContractor, setBorrowerContractor] = useState(null);
  const [adminFee, setAdminFee] = useState(null);
  const [subContractorNo, setSubContractorNo] = useState(null);
  const [employer, setEmployer] = useState(null);
  const [contractType, setContractType] = useState(null);
  const [subContractNo2, setSubContractNo2] = useState(null);
  const [subContractStartDate, setSubContractStartDate] = useState(null);
  const [emp2, setEmp2] = useState(null);
  const [paymentCertvalue, setPaymentCertvalue] = useState(null);
  const [certiCumValue, setCertiCumValue] = useState();
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);

  const BACKEND_URL = "http://localhost:8000";
  const API_URL = "http://localhost:5001/api";

  function formatNewDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    const monthFull = date.toLocaleString("default", { month: "long" });
    const month = monthFull.slice(0, 3); // Take only the first 3 letters
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  const handleUploadCC = async () => {
    try {
      if (!file) {
        console.error("First file is missing!");
        setStatus("Please select the first file.");
        return false;
      }

      const formData1 = new FormData();
      formData1.append("file", file);

      console.log("Uploading first file...");
      const response = await fetch(`${BACKEND_URL}/uploadfile/`, {
        method: "POST",
        body: formData1,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("First file uploaded successfully:", data);
      setPlaceofincorporation(
        data.content?.Placeofincorporation != null
          ? data.content?.Placeofincorporation
          : ""
      );
      setRegisteredAddress(
        data.content?.RegisteredAddress != null
          ? data.content?.RegisteredAddress
          : ""
      );
      setContactname(
        data.content?.Contactname != null ? data.content?.Contactname : ""
      );
      setContactemailaddress(
        data.content?.Contactemailaddress != null
          ? data.content?.Contactemailaddress
          : ""
      );
      setContactphonenumber(
        data.content?.Contactphonenumber != null
          ? data.content?.Contactphonenumber
          : ""
      );
      setBusinessRegistrationNumber(
        data.content?.BusinessRegistrationNumber != null
          ? data.content?.BusinessRegistrationNumber
          : ""
      );
      setBankAccNo(
        data.content?.BankAccountNumber !== null
          ? data.content?.BankAccountNumber
          : ""
      );
      setBankName(data.content?.BankName != null ? data.content?.BankName : "");
      setBenifiserName(
        data.content?.BeneficiaryName !== null
          ? data.content?.BeneficiaryName
          : ""
      );
      setBankCode(
        data.content?.BankCode !== null ? data.content?.BankCode : ""
      );
      setSwift(data.content?.SWIFT !== null ? data.content?.SWIFT : "");
      setErrorCodeCC(data.content?.status);

      return true;
    } catch (error) {
      console.error("Error uploading first file:", error);
      setStatus("Error uploading first file. Check console for details.");
      return false;
    }
  };

  const handleUploadTF = async () => {
    try {
      if (!file2) {
        console.error("Second file is missing!");
        setStatus("Please select the second file.");
        return;
      }
      const formData2 = new FormData();
      formData2.append("file", file2);

      console.log("Uploading second file...");
      const response = await fetch(`${BACKEND_URL}/uploadTFPRODBfile/`, {
        method: "POST",
        body: formData2,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      const data = await response.json();
      console.log("Second file uploaded successfully:", data);

      SetErrorCodeTF(data.contentTF?.status);
      setRiverchainID(data.contentTF?.TRANSACTIONID);
      setBorroerNameEng(data.contentTF?.BORROWER);
      setLenderNo(
        data.contentTF?.LENDER_NO !== null ? data.contentTF?.LENDER_NO : ""
      );
      setProductNo(
        data.contentTF?.PRODUCT_NO !== null ? data.contentTF?.PRODUCT_NO : ""
      );
      setFacilityLimit(
        data.contentTF?.FACILITYLIMIT_HK !== null
          ? data.contentTF?.FACILITYLIMIT_HK
          : ""
      );
      SetDrawDownAvailability(
        data.contentTF?.AVAILABILITYPERIOD_DAYS_MONTHS !== null
          ? data.contentTF?.AVAILABILITYPERIOD_DAYS_MONTHS
          : ""
      );
      setInterestRate(
        data.contentTF?.INTERESTRATE !== null
          ? (data.contentTF?.INTERESTRATE * 100).toFixed(2)
          : ""
      );
      setMaxTerm(
        data.contentTF?.MAXTERM_DAYS !== null
          ? data.contentTF?.MAXTERM_DAYS
          : ""
      );
      setRepaymentOne(
        data.contentTF?.REPAYMENT_NO_1 !== null
          ? data.contentTF?.REPAYMENT_NO_1
          : ""
      );
      setInvoiceAmount(
        data.contentTF?.INVOICEVALUE_HK !== null
          ? data.contentTF?.INVOICEVALUE_HK
          : ""
      );
      setInvoiceFinancing(
        data.contentTF?.DRAWDOWNLIMIT_PERCENTAGE_ !== null
          ? data.contentTF?.DRAWDOWNLIMIT_PERCENTAGE_
          : ""
      );

      setProjectDetails(
        data.contentTF?.MAINCONTRACT !== null
          ? data.contentTF?.MAINCONTRACT
          : ""
      );
      setContractStartDate(
        data.contentTF?.CONTRACTSTARTDATE !== null
          ? data.contentTF?.CONTRACTSTARTDATE
          : ""
      );
      setInvoiceNo(
        data.contentTF?.INVOICENO !== null ? data.contentTF?.INVOICENO : ""
      );
      setInvoiceDate(
        data.contentTF?.INVOICEDATE !== null ? data.contentTF?.INVOICEDATE : ""
      );
      setBorrowerContractor(
        data.contentTF?.MAINCONTRACTOR !== null
          ? data.contentTF?.MAINCONTRACTOR
          : ""
      );
      setAdminFee(
        data.contentTF?.ADMINFEE !== null
          ? (data.contentTF?.ADMINFEE * 100).toFixed(2)
          : ""
      );
      setSubContractorNo(
        data.contentTF?.SUBCONTRACT_NO !== null
          ? data.contentTF?.SUBCONTRACT_NO
          : ""
      );
      setEmployer(
        data.contentTF?.EMPLOYER !== null ? data.contentTF?.EMPLOYER : ""
      );
      setContractType(
        data.contentTF?.CONTRACTTYPE_NO !== null
          ? data.contentTF?.CONTRACTTYPE_NO
          : ""
      );
      setSubContractNo2(
        data.contentTF?.SUBCONTRACT_2 !== null
          ? data.contentTF?.SUBCONTRACT_2
          : ""
      );
      setSubContractStartDate(
        data.contentTF?.CONTRACTSTARTDATE_2 !== null
          ? data.contentTF?.CONTRACTSTARTDATE_2
          : ""
      );
      setEmp2(
        data.contentTF?.EMPLOYER_2 !== null ? data.contentTF?.EMPLOYER_2 : ""
      );
      setPaymentCertvalue(
        data.contentTF?.PAYMENTCERTVALUE_HK !== null
          ? data.contentTF?.PAYMENTCERTVALUE_HK
          : ""
      );
      setCertiCumValue(
        data.contentTF?.CERTIFIEDTODATE_EXCLVO_HK !== null
          ? data.contentTF?.CERTIFIEDTODATE_EXCLVO_HK
          : ""
      );
      return true;
    } catch (error) {
      console.error("Error uploading second file:", error);
      setStatus("Upload failed, please check the uploaded file");
    }
  };

  const handleUpload = async () => {
    if (!file || !file2) {
      setStatus("Please select both files before uploading.");
      return;
    }
    setLoading(true);
    setStatus("Uploading first file...");

    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    const firstFileSuccess = await handleUploadCC();

    if (firstFileSuccess) {
      console.log("First upload successful, now uploading second file...");
      setStatus("Uploading second file...");
      setFinalUpload(true);
      await handleUploadTF();
    } else {
      console.log("First upload failed, skipping second upload.");
    }

    setLoading(false);
  };

  useEffect(() => {
    if (errorCodeCC === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    if (errorCodeTF === "ERROR") {
      // setStatus("Somethig wrong with the Transaction File");
      setLoading(true);
      console.log("Loading:", loading);
      return;
    }

    // compantNameEng
    if (errorCodeCC === "OK" && errorCodeTF === "OK") {
      const newStartDate =
        contractStartDate && contractStartDate !== null
          ? formatNewDate(contractStartDate)
          : "";

      console.log("****************");
      console.log(newStartDate);

      const newInvoiceDate =
        invoiceDate && invoiceDate !== null ? formatNewDate(invoiceDate) : "";

      const newSubConStartDate =
        subContractStartDate && subContractStartDate !== null
          ? formatNewDate(subContractStartDate)
          : "";

      const newinvoiceAmount = invoiceAmount !== null ? invoiceAmount : 0;

      const newsubContractNo2 =
        subContractNo2 === undefined
          ? ""
          : subContractNo2 !== null
          ? subContractNo2
          : "";

      const newemp2 = emp2 === undefined ? "" : emp2 !== null ? emp2 : "";

      const newInvoiceFinancing = invoiceFinancing && invoiceFinancing * 100;

      const xmlData = `<?xml version="1.0" encoding="UTF-8"?>
<isheet recordcount="string">
	<id>0</id>
	<title>string</title>
	<description>string</description>
	<status>string</status>
	<accesstype>string</accesstype>
	<type>string</type>
	<viewlink>string</viewlink>
	<allowsections>string</allowsections>
	<allowlookup>string</allowlookup>
	<displayisheet>string</displayisheet>
	<searchasdefaultview>string</searchasdefaultview>
	<enableversion>string</enableversion>
	<enablesheetalerter>string</enablesheetalerter>
	<alertercondition>string</alertercondition>
	<overrideitemmodifieddate>string</overrideitemmodifieddate>
	<enablebulkinsertupdate>string</enablebulkinsertupdate>
	<fielddescriptions>string</fielddescriptions>
	<enablerowlocking>string</enablerowlocking>
	<setcharlimittruncatemultilinetextenabled>string</setcharlimittruncatemultilinetextenabled>
	<setcharlimittruncatemultilinetextval>string</setcharlimittruncatemultilinetextval>
	<allowchoicelistvaluesforreuse>string</allowchoicelistvaluesforreuse>
	<allowscorelistvaluesforreuse>string</allowscorelistvaluesforreuse>
	<allowIsheetComments>string</allowIsheetComments>
	<shareRecordsLimit>0</shareRecordsLimit>
	<shareRecordsLimitEnabled>0</shareRecordsLimitEnabled>
	<enableIsheetAddRecordFormSharing>string</enableIsheetAddRecordFormSharing>
	<allowViewBaseRendering>string</allowViewBaseRendering>
	<columns>
		<column sequence="string" attributecolumnid="string">
			<columnid>0</columnid>
			<name>test</name>
			<type>0</type>
			<status>0</status>
			<systemgeneratedtype>string</systemgeneratedtype>
			<section>0</section>
			<description>string</description>
			<addtodefaultview>string</addtodefaultview>
			<columnconditionstate>string</columnconditionstate>
			<columnconditions>
				<row>
					<rowid>0</rowid>
					<columnid>0</columnid>
					<operatorid>0</operatorid>
					<oprand>string</oprand>
					<logicaltype>string</logicaltype>
					<sheetfiltervaluetypeid>string</sheetfiltervaluetypeid>
					<displaytype>string</displaytype>
					<scoreConditionTypeid>0</scoreConditionTypeid>
					<sourceColumnId>0</sourceColumnId>
				</row>
			</columnconditions>
			<columnspecificdetail>
				<defaultvalue>string</defaultvalue>
				<columnwidth>string</columnwidth>
				<sheetname>string</sheetname>
				<sitename>string</sitename>
				<mandatory>string</mandatory>
				<allowsearch>string</allowsearch>
				<maxchars>0</maxchars>
				<allowfieldfromanotherisheet>string</allowfieldfromanotherisheet>
				<allowrichhtmltext>string</allowrichhtmltext>
				<numberoflines>0</numberoflines>
				<displaymethod>string</displaymethod>
				<includeotheroption>string</includeotheroption>
				<singleormultileselectioninsearch>string</singleormultileselectioninsearch>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<includeinalertpreferences>string</includeinalertpreferences>
				<min>string</min>
				<max>string</max>
				<decimalplaces>0</decimalplaces>
				<showthousandseparators>string</showthousandseparators>
				<showaspercentage>string</showaspercentage>
				<symbolId>string</symbolId>
				<numberDecimalFormat>DOT_AS_DECIMAL/COMMA_AS_DECIMAL</numberDecimalFormat>
				<symbolPosition>before/after</symbolPosition>
				<formattype>string</formattype>
				<dateformat>string</dateformat>
				<defaultdateandtime>string</defaultdateandtime>
				<sheetlookup>string</sheetlookup>
				<fielddisplay>string</fielddisplay>
				<allowmultipleusers>string</allowmultipleusers>
				<methodtype>string</methodtype>
				<sheetids>string</sheetids>
				<allowuserstorenamelinks>string</allowuserstorenamelinks>
				<sheetid>0</sheetid>
				<columnids>string</columnids>
				<viewid>0</viewid>
				<allowmultiplevalues>string</allowmultiplevalues>
				<restrictdelete>string</restrictdelete>
				<displaycolumnnameprefix>string</displaycolumnnameprefix>
				<linkname>string</linkname>
				<donotcountweekendsonlycountmontofri>string</donotcountweekendsonlycountmontofri>
				<joinconditions>
					<joincondition>
						<currentsheetcolumnid>0</currentsheetcolumnid>
						<targetsheetcolumnid>0</targetsheetcolumnid>
					</joincondition>
				</joinconditions>
				<formula>string</formula>
				<startvalue>0</startvalue>
				<prefix>string</prefix>
				<postfix>string</postfix>
				<minlength>0</minlength>
				<lookupglossarysheetid>0</lookupglossarysheetid>
				<lookupglossarysheetviewid>0</lookupglossarysheetviewid>
				<width>0</width>
				<otherscorevalue>string</otherscorevalue>
				<importdatafromexternalsource>string</importdatafromexternalsource>
				<analysisengine>string</analysisengine>
				<attachmentcustomfolderid/>
				<singleLineEmailValidation>string</singleLineEmailValidation>
				<readonly>string</readonly>
				<virtualColumn>0</virtualColumn>
				<externalSource>string</externalSource>
				<allowInlineEditing>string</allowInlineEditing>
			</columnspecificdetail>
			<rawdata>
				<value>string</value>
				<choices>
					<choice>
						<id>string</id>
						<label>string</label>
						<score>string</score>
						<color>string</color>
						<imageid>0</imageid>
					</choice>
				</choices>
				<date>string</date>
				<time>string</time>
				<linkdisplayname>string</linkdisplayname>
				<linkdisplayurl>string</linkdisplayurl>
				<lookups>
					<lookup>
						<id>string</id>
						<email>string</email>
						<userlookuptype>string</userlookuptype>
					</lookup>
				</lookups>
				<folders>
					<folder>
						<folderid>string</folderid>
					</folder>
				</folders>
				<documents>
					<document>
						<docid>string</docid>
					</document>
				</documents>
				<fromdate>string</fromdate>
				<todate>string</todate>
				<attachments>
					<attachment>
						<file>string</file>
						<name>string</name>
						<order>string</order>
						<id>0</id>
						<extension>string</extension>
						<parentfolderid>0</parentfolderid>
						<filehttplink>string</filehttplink>
						<folderpath>string</folderpath>
						<folderhttplink>string</folderhttplink>
						<filesize>0</filesize>
						<redactionstatus>true</redactionstatus>
						<siteid>0</siteid>
						<displayname>string</displayname>
					</attachment>
				</attachments>
				<isheetitems>
					<isheetitem>
						<recordid>string</recordid>
						<linkname>string</linkname>
						<apilink>string</apilink>
						<httplink>string</httplink>
					</isheetitem>
				</isheetitems>
				<daydifference>string</daydifference>
			</rawdata>
			<colViewPosition>0</colViewPosition>
			<columntype>string</columntype>
			<createdDate>2025-04-08T07:16:21.504Z</createdDate>
			<modifiedDate>2025-04-08T07:16:21.504Z</modifiedDate>
			<injectReferenceColumn>0</injectReferenceColumn>
			<parentColumnID>0</parentColumnID>
			<reusecolumnidfromisheet>0</reusecolumnidfromisheet>
			<choicelistid>0</choicelistid>
			<editpermission>0</editpermission>
			<templatesheetcolumnid>0</templatesheetcolumnid>
			<uploadpermission>0</uploadpermission>
			<deletepermission>0</deletepermission>
			<sourceSheetID>0</sourceSheetID>
		</column>
	</columns>
	<metadata>
		<viewName>string</viewName>
		<viewId>0</viewId>
		<sheetName>string</sheetName>
		<siteId>0</siteId>
		<siteName>string</siteName>
		<sheetId>0</sheetId>
	</metadata>
	<head>
      <headcolumn sequence="1" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="741">
        <columnvalue><![CDATA[Created by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="2" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="742">
        <columnvalue><![CDATA[Created date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="3" columntypealias="SHEET_COLUMN_TYPE_LOOKUP" columntypeid="6" columnid="743">
        <columnvalue><![CDATA[Modified by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="4" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="744">
        <columnvalue><![CDATA[Modified date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="5" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="745">
        <columnvalue><![CDATA[Riverchain ID]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="6" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="746">
        <columnvalue><![CDATA[Borrower Name English]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="7" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="747">
        <columnvalue><![CDATA[Borrower Name Chinese]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="8" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="748">
        <columnvalue><![CDATA[Borrower BR No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="9" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="749">
        <columnvalue><![CDATA[Borrower Contact Details - Person]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="10" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="750">
        <columnvalue><![CDATA[Borrower Contact Details - Phone]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="11" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="751">
        <columnvalue><![CDATA[Borrower Contact Details - Email]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="12" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="752">
        <columnvalue><![CDATA[Borrower Address]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="13" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="753">
        <columnvalue><![CDATA[Borrower Place of Incorporation]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="14" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="754">
        <columnvalue><![CDATA[Lender Company Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="15" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="755">
        <columnvalue><![CDATA[Loan Type (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="16" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="756">
        <columnvalue><![CDATA[Loan Type 2.2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="17" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="757">
        <columnvalue><![CDATA[Facility Limit (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="18" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="758">
        <columnvalue><![CDATA[Facility Limit (2.2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="19" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="759">
        <columnvalue><![CDATA[Final Maturity Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="20" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="760">
        <columnvalue><![CDATA[Drawdown Availability Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="21" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="761">
        <columnvalue><![CDATA[Interest Rates]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="22" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="762">
        <columnvalue><![CDATA[HIBOR Interest Rates]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="23" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="763">
        <columnvalue><![CDATA[Repayment Type (2.1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="24" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="764">
        <columnvalue><![CDATA[Repayment Type 2]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="25" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="765">
        <columnvalue><![CDATA[Invoice amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="26" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="766">
        <columnvalue><![CDATA[Invoice Financing %]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="27" columntypealias="SHEET_COLUMN_TYPE_MULTIPLE_LINE_TEXT" columntypeid="2" columnid="767">
        <columnvalue><![CDATA[Borrower's Contractor]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="28" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="768">
        <columnvalue><![CDATA[Admin Fee]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="29" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="769">
        <columnvalue><![CDATA[Sub Contract No. (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="30" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="770">
        <columnvalue><![CDATA[Sub Contract Project Details (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="31" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="771">
        <columnvalue><![CDATA[sub contract date (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="32" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="772">
        <columnvalue><![CDATA[Sub Contract Invoice No (1)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="33" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="773">
        <columnvalue><![CDATA[Sub contract Invoice date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="34" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="774">
        <columnvalue><![CDATA[Sub contract invoice amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="35" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="859">
        <columnvalue><![CDATA[Borrower's Bank Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="36" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="860">
        <columnvalue><![CDATA[Borrower's Bank Account No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="37" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="861">
        <columnvalue><![CDATA[Borrower's Bank Account Name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="38" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="862">
        <columnvalue><![CDATA[Borrower's Bank Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="39" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="863">
        <columnvalue><![CDATA[Borrower's Bank Swift Code]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="40" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="864">
        <columnvalue><![CDATA[Borrower's Emoloyer]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="41" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="865">
        <columnvalue><![CDATA[Contract Type]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="42" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="866">
        <columnvalue><![CDATA[Payment Application No.]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="43" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="867">
        <columnvalue><![CDATA[Payment Application Amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="44" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="868">
        <columnvalue><![CDATA[Collection Agent signor name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="45" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="869">
        <columnvalue><![CDATA[Collection Agent signor title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="46" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="870">
        <columnvalue><![CDATA[Lender Company signor name]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="47" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="871">
        <columnvalue><![CDATA[Lender company signor title]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="48" columntypealias="SHEET_COLUMN_TYPE_CHOICE" columntypeid="3" columnid="872">
        <columnvalue><![CDATA[Collect Agent company name]]></columnvalue>
      </headcolumn>
       <headcolumn sequence="49" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="873">
        <columnvalue><![CDATA[Payment Application date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="50" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="874">
        <columnvalue><![CDATA[Payment Certificate Number]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="51" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="875">
        <columnvalue><![CDATA[Payment Certificate Date]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="52" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="876">
        <columnvalue><![CDATA[Payment Certificate issued by]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="53" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="877">
        <columnvalue><![CDATA[Payment certificate amount]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="54" columntypealias="SHEET_COLUMN_TYPE_NUMBER" columntypeid="4" columnid="878">
        <columnvalue><![CDATA[Payment Certificate amount (Cumulative)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="55" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1008">
        <columnvalue><![CDATA[Extension Approved Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="56" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1009">
        <columnvalue><![CDATA[Extension Request Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="57" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1010">
        <columnvalue><![CDATA[Maximum no. of extensions]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="58" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1011">
        <columnvalue><![CDATA[Number of extensions]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="59" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1012">
        <columnvalue><![CDATA[Supplier invoice issue no of days]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="60" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1013">
        <columnvalue><![CDATA[Term/Revolving Loan Purpose]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="61" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1014">
        <columnvalue><![CDATA[Term/Revolving Loan Drawdown Availability]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="62" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1015">
        <columnvalue><![CDATA[Name of Security Provider]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="63" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1017">
        <columnvalue><![CDATA[Voluntary Prepayment Notice Period]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="64" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1018">
        <columnvalue><![CDATA[Conditions Subsequent Documents Delivery]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="65" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1106">
        <columnvalue><![CDATA[Sub Contract No. (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="66" columntypealias="SHEET_COLUMN_TYPE_DATE_AND_TIME" columntypeid="5" columnid="1107">
        <columnvalue><![CDATA[Sub Contract Date (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="67" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1108">
        <columnvalue><![CDATA[Sub Contract Project Details (2)]]></columnvalue>
      </headcolumn>
      <headcolumn sequence="68" columntypealias="SHEET_COLUMN_TYPE_SINGLE_LINE_TEXT" columntypeid="1" columnid="1109">
        <columnvalue><![CDATA[Borrower's Contractor (2)]]></columnvalue>
      </headcolumn>
    </head>
    <data>
		<item externalid="" itemsequence="200" itemid="201">
        <column sequence="5" attributecolumnid="745">
          <rawdata>
            <value><![CDATA[${riverchainID}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${riverchainID}]]></value>
          </displaydata>
        </column>
		<column sequence="6" attributecolumnid="746">
          <rawdata>
            <value><![CDATA[${borrowerNameEng}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${borrowerNameEng}]]></value>
          </displaydata>
        </column>
		<column sequence="7" attributecolumnid="747">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
		<column sequence="8" attributecolumnid="748">
          <rawdata>
            <value><![CDATA[${businessRegistrationNumber}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${businessRegistrationNumber}]]></value>
          </displaydata>
        </column>
		<column sequence="9" attributecolumnid="749">
          <rawdata>
            <value><![CDATA[${contactname}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactname}]]></value>
          </displaydata>
        </column>
		<column sequence="10" attributecolumnid="750">
          <rawdata>
            <value><![CDATA[${contactphonenumber}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactphonenumber}]]></value>
          </displaydata>
        </column>
		<column sequence="11" attributecolumnid="751">
          <rawdata>
            <value><![CDATA[${contactemailaddress}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${contactemailaddress}]]></value>
          </displaydata>
        </column>
		<column sequence="12" attributecolumnid="752">
          <rawdata>
            <value><![CDATA[${registeredAddress}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${registeredAddress}]]></value>
          </displaydata>
        </column>
		<column sequence="13" attributecolumnid="753">
          <rawdata>
            <value><![CDATA[${placeofincorporation}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${placeofincorporation}]]></value>
          </displaydata>
        </column>
		<column sequence="14" attributecolumnid="754">
          <rawdata>
				<choices>
					<choice>
							<id>${lenderNo}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
		<column sequence="15" attributecolumnid="755">
          <rawdata>
				<choices>
					<choice>
							<id>${productNo}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
		<column sequence="16" attributecolumnid="756">
          <rawdata>
				<choices>
					<choice>
							<id></id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="17" attributecolumnid="757">
          <rawdata>
            <value><![CDATA[${facilityLimit}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${facilityLimit}]]></value>
          </displaydata>
        </column>
        <column sequence="18" attributecolumnid="758">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
        <column sequence="19" attributecolumnid="759">
          <rawdata>
            <value><![CDATA[${maxTerm}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${maxTerm}]]></value>
          </displaydata>
        </column>
        <column sequence="20" attributecolumnid="760">
          <rawdata>
            <value><![CDATA[${drawDownAvailability}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${drawDownAvailability}]]></value>
          </displaydata>
        </column>
        <column sequence="21" attributecolumnid="761">
          <rawdata>
            <value><![CDATA[${interestRate}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${interestRate}]]></value>
          </displaydata>
        </column>
        <column sequence="22" attributecolumnid="762">
          <rawdata>
            <value><![CDATA[]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[]]></value>
          </displaydata>
        </column>
        <column sequence="23" attributecolumnid="763">
          <rawdata>
				<choices>
					<choice>
							<id>${repaymentOne}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="24" attributecolumnid="764">
          <rawdata>
				<choices>
					<choice>
							<id></id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="25" attributecolumnid="765">
          <rawdata>
            <value><![CDATA[${newinvoiceAmount}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newinvoiceAmount}]]></value>
          </displaydata>
        </column>
        <column sequence="26" attributecolumnid="766">
          <rawdata>
            <value><![CDATA[${newInvoiceFinancing}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceFinancing}]]></value>
          </displaydata>
        </column>
        <column sequence="27" attributecolumnid="767">
          <rawdata>
            <value><![CDATA[${borrowerContractor}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${borrowerContractor}]]></value>
          </displaydata>
        </column>
        <column sequence="28" attributecolumnid="768">
          <rawdata>
            <value><![CDATA[${adminFee}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${adminFee}]]></value>
          </displaydata>
        </column>
        <column sequence="29" attributecolumnid="769">
          <rawdata>
            <value><![CDATA[${subContractorNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${subContractorNo}]]></value>
          </displaydata>
        </column>
        <column sequence="30" attributecolumnid="770">
          <rawdata>
            <value><![CDATA[${projectDetails}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${projectDetails}]]></value>
          </displaydata>
        </column>
        <column sequence="31" attributecolumnid="771">
          <rawdata>
            <date><![CDATA[${newStartDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newStartDate}]]></value>
          </displaydata>
        </column>
        <column sequence="32" attributecolumnid="772">
          <rawdata>
            <value><![CDATA[${invoiceNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceNo}]]></value>
          </displaydata>
        </column>
        <column sequence="33" attributecolumnid="773">
          <rawdata>
            <date><![CDATA[${newInvoiceDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceDate}]]></value>
          </displaydata>
        </column>
        <column sequence="34" attributecolumnid="774">
          <rawdata>
            <value><![CDATA[${invoiceAmount}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceAmount}]]></value>
          </displaydata>
        </column>
        <column sequence="35" attributecolumnid="859">
          <rawdata>
            <value><![CDATA[${bankName}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankName}]]></value>
          </displaydata>
        </column>
        <column sequence="36" attributecolumnid="860">
          <rawdata>
            <value><![CDATA[${bankAccNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankAccNo}]]></value>
          </displaydata>
        </column>
        <column sequence="37" attributecolumnid="861">
          <rawdata>
            <value><![CDATA[${benifiserName}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${benifiserName}]]></value>
          </displaydata>
        </column>
        <column sequence="38" attributecolumnid="862">
          <rawdata>
            <value><![CDATA[${bankCode}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${bankCode}]]></value>
          </displaydata>
        </column>
        <column sequence="39" attributecolumnid="863">
          <rawdata>
            <value><![CDATA[${swift}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${swift}]]></value>
          </displaydata>
        </column>
        <column sequence="40" attributecolumnid="864">
          <rawdata>
            <value><![CDATA[${employer}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${employer}]]></value>
          </displaydata>
        </column>
        <column sequence="41" attributecolumnid="865">
          <rawdata>
				<choices>
					<choice>
							<id>${contractType}</id>
					</choice>
				</choices>
            </rawdata>
        </column>
        <column sequence="42" attributecolumnid="866">
          <rawdata>
            <value><![CDATA[${invoiceNo}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceNo}]]></value>
          </displaydata>
        </column>
        <column sequence="43" attributecolumnid="867">
          <rawdata>
            <value><![CDATA[${invoiceAmount}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${invoiceAmount}]]></value>
          </displaydata>
        </column>
        <column sequence="49" attributecolumnid="873">
          <rawdata>
            <date><![CDATA[${newInvoiceDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newInvoiceDate}]]></value>
          </displaydata>
        </column>
        <column sequence="53" attributecolumnid="877">
          <rawdata>
            <value><![CDATA[${paymentCertvalue}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${paymentCertvalue}]]></value>
          </displaydata>
        </column>
        <column sequence="54" attributecolumnid="878">
          <rawdata>
            <value><![CDATA[${certiCumValue}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${certiCumValue}]]></value>
          </displaydata>
        </column>
        <column sequence="65" attributecolumnid="1106">
          <rawdata>
            <value><![CDATA[${newsubContractNo2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newsubContractNo2}]]></value>
          </displaydata>
        </column>
        <column sequence="66" attributecolumnid="1107">
          <rawdata>
            <date><![CDATA[${newSubConStartDate}]]></date>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newSubConStartDate}]]></value>
          </displaydata>
        </column>
        <column sequence="67" attributecolumnid="1108">
          <rawdata>
            <value><![CDATA[${newsubContractNo2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newsubContractNo2}]]></value>
          </displaydata>
        </column>
        <column sequence="68" attributecolumnid="1109">
          <rawdata>
            <value><![CDATA[${newemp2}]]></value>
          </rawdata>
          <displaydata>
            <value><![CDATA[${newemp2}]]></value>
          </displaydata>
        </column>
      </item>
	</data>
	<sheettypeid>0</sheettypeid>
	<enablesmartform>string</enablesmartform>
	<allowDeletedItemsView>string</allowDeletedItemsView>
	<allowAllColumnsInCustomView>string</allowAllColumnsInCustomView>
</isheet>`;

      const postData = async () => {
        try {
          const res = await axios.post(`${API_URL}/postb`, xmlData, {
            headers: {
              "Content-Type": "application/xml",
            },
          });

          console.log("Response_data:", res.data.progressivekey);
          setStatus("iSheet successfully generated");
          setStatusRes(res.data?.progressivekey);
          onUploadSuccess();
          setTimeout(() => {
            setStatus(null);
          }, 5000);
          removeFile();
          removeFile2();
        } catch (error) {
          console.error("Error sending data:", error);
        }
      };

      postData();
    }
  }, [finalUpload]);

  const handleFile1Change = (e) => {
    const selectedFile = e.target.files[0];
    console.log("selectedFile:", selectedFile);
    if (selectedFile) {
      setFile(selectedFile);
      setStatusCC(null);
    }
  };

  const isRemovingRef = useRef(false);
  const isRemovingRef2 = useRef(false);

  const removeFile = () => {
    isRemovingRef.current = true;
    setFile(null);
    setStatusCC(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  useEffect(() => {
    if (isRemovingRef.current) {
      isRemovingRef.current = false;
      return;
    }

    if (file) {
      console.log("File:", file);
      handleUploadCC();
    }

    if (errorCodeCC === "ERROR") {
      setStatusCC("Upload failed validation error");
    } else if (errorCodeCC === "OK") {
      setStatusCC("");
    }
  }, [errorCodeCC, file]);

  const handleFile2Change = (e) => {
    const selectedFile2 = setFile2(e.target.files[0]);
    console.log("selectedFile2:", selectedFile2);
    if (selectedFile2) {
      setFile2(selectedFile2);
      setStatusTF(null);
    }
  };

  const removeFile2 = () => {
    isRemovingRef2.current = true;
    setFile2(null);
    setStatusTF(null);
    setLoading(false);
    if (fileInputRef2.current) {
      fileInputRef2.current.value = "";
    }
  };

  useEffect(() => {
    if (isRemovingRef2.current) {
      isRemovingRef2.current = false;
      return; // Skip status update when removing
    }

    if (file2) {
      console.log("File:", file2);
      handleUploadTF();
    }

    if (errorCodeTF === "ERROR") {
      setStatusTF("Upload failed validation error");
      setLoading(true);
    } else if (errorCodeTF === "OK") {
      console.log("Response status:", statusRes);
      setStatusTF("");
      setLoading(false);
    }
  }, [errorCodeTF, file2]);

  return (
    <>
      <h4
        style={{ textAlign: "center", marginBottom: "10px", marginTop: "30px" }}
      >
        Upload Client Card & Transaction File
      </h4>
      <hr />
      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Client Card (CC) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile1Change} ref={fileInputRef} />
      </div>

      {file && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            marginBottom: "20px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "25px",
              height: "25px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusCC && (
        <p
          style={{
            color: statusCC.includes("error")
              ? "#f44336"
              : statusCC.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "-20px",
            textAlign: "center",
          }}
        >
          {statusCC}
        </p>
      )}

      <div
        style={{
          backgroundColor: "#f3f3f3",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <label style={{ fontWeight: "bold" }}>
          Upload Transaction File (TF) <span className="text-danger">*</span>
        </label>
        <br />
        <input type="file" onChange={handleFile2Change} ref={fileInputRef2} />
      </div>

      {file2 && (
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            marginTop: "10px",
            position: "relative",
          }}
        >
          <div>
            <p style={{ margin: "5px 0", fontWeight: "bold" }}>{file2.name}</p>
            <p style={{ margin: "5px 0", color: "#555" }}>
              {(file2.size / 1024).toFixed(2)} KB
            </p>
          </div>
          <button
            onClick={removeFile2}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "#f44336",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
        </div>
      )}

      {statusTF && (
        <p
          style={{
            color: statusTF.includes("error")
              ? "#f44336"
              : statusTF.includes("successfully")
              ? "green"
              : "grey",
            marginTop: "5px",
            textAlign: "center",
          }}
        >
          {statusTF}
        </p>
      )}

      <button
        onClick={handleUpload}
        disabled={loading}
        className="btn btn-primary"
        style={{ marginTop: "30px" }}
      >
        {loading
          ? "Generating isheet"
          : loading === "error"
          ? "something wrong with the files"
          : "Generate iSheet"}
      </button>

      {status && (
        <p
          style={{
            backgroundColor: status.includes("error")
              ? "#7b1103"
              : status.includes("successfully")
              ? "green"
              : "grey",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            color: "#fff",
          }}
        >
          {status}
          {statusRes?.progressivekey}
        </p>
      )}
    </>
  );
};

export default FileUpload;
